module.exports = "/_next/static/images/RobustMarketingAppstore-3509fe8cdaac3fc1b8a6c8b223f0f3a7.webp";